
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"28","height":"28","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_499_4476)","fill":"#282828"}},[_c('path',{attrs:{"d":"M10.209 20.547v5.41a.876.876 0 00.875.876.875.875 0 00.705-.357l3.165-4.307-4.745-1.622zM27.633.162A.875.875 0 0026.72.1L.47 13.808a.877.877 0 00.122 1.604l7.297 2.494L23.43 4.618 11.404 19.107l12.23 4.18a.879.879 0 00.737-.08.88.88 0 00.411-.62l3.209-21.582a.876.876 0 00-.358-.843z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_499_4476"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h28v28H0z"}})])])])
          )
        }
      }
    